import type { Level } from '@tiptap/extension-heading'
import Heading from '@tiptap/extension-heading'
import { mergeAttributes } from '@tiptap/core'

export const styling: { [k in Level]: { class: string; fontSize: number } } = {
  1: {
    class: 'font-300 c-theme-preset c-theme-preset--h_1',
    fontSize: 44,
  },
  2: {
    class: 'font-300 c-theme-preset c-theme-preset--h_2',
    fontSize: 36,
  },
  3: {
    class: 'font-400 c-theme-preset c-theme-preset--h_3',
    fontSize: 28,
  },
  4: {
    class: 'c-theme-preset c-theme-preset--h_4',
    fontSize: 24,
  },
  5: {
    class: 'c-theme-preset c-theme-preset--h_5',
    fontSize: 24,
  },
  6: {
    class: 'c-theme-preset c-theme-preset--h_6',
    fontSize: 24,
  },
}

export const HeadingExtended = Heading.extend({
  renderHTML({ node, HTMLAttributes }) {
    const hasLevel = this.options.levels.includes(node.attrs.level)
    const level: Level = hasLevel ? node.attrs.level : this.options.levels[0]
    const classes: string = styling[level]?.class ?? ''

    return [`h${level}`, mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, { class: classes }), 0]
  },
})

export default HeadingExtended
